<div class="insta-topics-dialog">

  <button mat-icon-button class="button d-none d-md-block button--icon button--transparent dialog-close-button" mat-dialog-close>
    <lib-icon icon="x" [size]="24"></lib-icon>
  </button>

  <lib-swiper
    class="dialog-slider"
    [slides]="topics"
    [options]="swiperOptions">

    <ng-template swiperContent let-slide="item" let-index="index">
      @if (index === swiperComponent?.swiper?.activeIndex && topicCard) {
        <div class="slider-navigation" [class.d-none]="!swiperComponent?.canSlide() || !topicCard?.visibleCards()?.length">
          <button
            mat-icon-button
            class="button button--icon button--icon-rounded button--black slider-navigation-button dialog-slider-prev"
            [class.d-none]="swiperComponent?.swiper?.isBeginning && topicCard?.activeCardIndex() === 0"
            (click)="topicCard.prevStory()">
            <lib-icon icon="caret-left"></lib-icon>
          </button>
          <button
            mat-icon-button
            class="button button--icon button--icon-rounded button--black slider-navigation-button dialog-slider-next"
            [class.d-none]="swiperComponent?.swiper?.isEnd && (topicCard?.activeCardIndex() === topicCard?.visibleCards()?.length - 1)"
            (click)="topicCard.nextStory()">
            <lib-icon icon="caret-right"></lib-icon>
          </button>
        </div>
      }

      <div class="slider-card-container" (click)="swiperComponent?.swiper.slideTo(index)">

        <lib-insta-topic-card
          #topicCard
          [topic]="slide.topic"
          [cardsSource]="slide.cardsSource"
          [muted]="muted"
          [active]="index === swiperComponent?.swiper?.activeIndex"
          (mutedChanged)="mutedChanged($event)"
          (navigate)="closeDialog($event)"
          (nextTopic)="swiperComponent?.swiper?.slideNext()"
          (prevTopic)="swiperComponent?.swiper?.slidePrev()"
          (markAsViewed)="cardViewed.next({ topic: slide.topic, card: $event })">
        </lib-insta-topic-card>

      </div>
    </ng-template>
  </lib-swiper>


</div>
